// import external dependencies
import 'jquery';
import '@fortawesome/fontawesome-free/js/all.js';
import '@googlemaps/js-api-loader';
import 'malihu-custom-scrollbar-plugin-3.1.7/jquery.mCustomScrollbar.concat.min.js';
import 'magnific-popup/dist/jquery.magnific-popup.js';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateBranch from './routes/templateBranch';
import singleGospelEnterprises from './routes/singleGospelEnterprises';
import regions from './routes/regions';
import centers from './routes/centers';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  //Branch Template Page
  templateBranch,
  //Gospel Enterprise Single Item
  singleGospelEnterprises,
  //Regions page with Google Maps API
  regions, centers,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js